import React from 'react';
import {
  Form,
  Field,
  Formik,
} from 'formik';
import {
  withApi,
  withNotification,
} from 'wrappers';
import {
  TextBase,
  ButtonSave,
  ButtonCancel,
} from 'components';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { messages } from 'constantes';
import endPoints from 'endPoints/endPoints';

const validationSchema = Yup.object({
  pregunta: Yup.string().required('El campo es requerido'),
});

const EnviarPreguntaForm = ({
  open,
  doPost,
  onClose,
  appSuccess,
  genericException,
}) => {
  const ep = endPoints.centroAyuda.procesos.enviarPreguntas;
  const state = {
    modulo: '',
    pregunta: '',
    funcionalidad: '',
  };

  const mapValues = (values) => {
    const {
      modulo,
      pregunta,
      funcionalidad,
    } = values;

    return {
      modulo,
      pregunta,
      funcionalidad,
    };
  };

  const onSubmit = async (formValues) => {
    try {
      await doPost({
        url: ep.base,
        data: mapValues(formValues),
      });
      appSuccess(messages.crud.new);
      onClose();
    } catch (e) {
      genericException(e);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          ENVIAR PREGUNTAS
        </DialogTitle>
        <Formik
          enableReinitialize
          onSubmit={onSubmit}
          initialValues={state}
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
              <DialogContent>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    xl={12}
                  >
                    <Field
                      label="Pregunta"
                      name="pregunta"
                      component={TextBase}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    xl={12}
                  >
                    <Field
                      label="Módulo"
                      name="modulo"
                      component={TextBase}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    xl={12}
                  >
                    <Field
                      label="Funcionalidad"
                      name="funcionalidad"
                      component={TextBase}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <ButtonCancel onClick={onClose} />
                <ButtonSave label="Guardar" />
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

EnviarPreguntaForm.propTypes = {
  open: PropTypes.bool,
  doPost: PropTypes.func,
  onClose: PropTypes.func,
  appSuccess: PropTypes.func,
  genericException: PropTypes.func,
};

export default withApi(withNotification(EnviarPreguntaForm));
